import type { useT } from '../../app/i18n.js';

/**
 * The canvas's strings, in one place.
 *
 * Four callers - automation, journey, chatbot, approval - and one label table.
 * Four copies would be four chances for "Not reached" to become "Skipped" on
 * one screen and not the others, and the words are how a person reads a run
 * back.
 */
export function flowCanvasLabels(t: ReturnType<typeof useT>) {
  return {
    palette: t('flow.palette'),
    canvas: t('flow.canvas'),
    addStep: (label: string) => t('flow.addStep', { values: { label } }),
    removeStep: (label: string) => t('flow.removeStep', { values: { label } }),
    step: (sequence: string) => t('flow.step', { values: { sequence } }),
    tookBranch: (branch: string) => t('flow.tookBranch', { values: { branch } }),
    notReached: t('flow.notReached'),
    input: t('flow.input'),
    output: t('flow.output'),
    atThisStep: (count: string) => t('flow.atThisStep', { values: { count } }),
    problems: t('flow.problems'),
  };
}
